<template>
  <Drawer width="900" title="选择大题" v-model="showSectionPicker"
    scrollable @on-close="closePicker" @on-ok="closePicker">
    <div class="section-picker">
      <Split v-model="split" mode="vertical">
        <div slot="top" class="split-pane">
          <Collapse simple v-model="tableToolsPanel" class="table-tools-panel" accordion>
            <Panel name="filter" hide-arrow>
              <div class="table-tools-panel-title"><Icon class="table-tools-panel-title-icon" type="ios-funnel" />筛选</div>
              <div class="pull-right">
                <Tooltip content="刷新结果">
                  <Button @click.stop="refresh" type="text" size="large" icon="ios-refresh"></Button>
                </Tooltip>
                <Divider type="vertical" />
                <Tooltip :content="expandText">
                  <Button type="text" size="large" :icon="tableToolsPanel.indexOf('filter')>-1? 'ios-arrow-up':'ios-arrow-down'"></Button>
                </Tooltip>
              </div>
              <div slot="content">
                <div class="padding-top-20"></div>
                <Form ref="filterForm" :model="filterModel" inline :show-message="false" :label-width="110">
                  <Row :gutter="8">
                    <i-col span="8">
                      <FormItem label="名称" prop="name">
                        <Input v-model="filterModel.name" placeholder="输入名称" />
                      </FormItem>
                    </i-col>
                    <i-col span="8">
                      <FormItem label="标题" prop="title">
                        <Input v-model="filterModel.title" placeholder="输入标题" />
                      </FormItem>
                    </i-col>
                  </Row>
                  <Row :gutter="8">
                    <i-col span="8">
                      <FormItem label="自评" prop="isSelfAppraise">
                        <RadioGroup v-model="filterModel.isSelfAppraise" type="button">
                          <Radio :label="null">不限</Radio>
                          <Radio :label="true">是</Radio>
                          <Radio :label="false">否</Radio>
                        </RadioGroup>
                      </FormItem>
                    </i-col>
                    <i-col span="8">
                      <FormItem label="附件" prop="isAttachment">
                        <RadioGroup v-model="filterModel.isAttachment" type="button">
                          <Radio :label="null">不限</Radio>
                          <Radio :label="true">是</Radio>
                          <Radio :label="false">否</Radio>
                        </RadioGroup>
                      </FormItem>
                    </i-col>
                  </Row>
                  <Row :gutter="8">
                    <i-col span="16">
                      <FormItem style="width: 100%; text-align:right">
                        <Button type="primary" size="large" style="width:144px;" @click="refresh">查询</Button>
                        <Divider type="vertical" />
                        <Button type="error" ghost size="large" @click="$refs['filterForm'].resetFields()">重置</Button>
                      </FormItem>
                    </i-col>
                  </Row>
                </Form>
              </div>
            </Panel>
          </Collapse>
          <div class="padding-top-10"></div>
          <div class="padding-top-10"></div>
          <!-- <Alert type="success" show-icon><b>导入完成！</b>成功 1 条，失败 0 条。</Alert> -->
          <Table border ref="dataTable"
            size="small"
            stripe
            :columns="columns"
            @on-sort-change="tableSortChange"
            :data="data">
          </Table>
          <Page class="pager"
            :total="totalCount"
            :current="currentPageIndex"
            @on-change="changePageIndex"
            @on-page-size-change="changePageSize"
            size="small"
            show-elevator
            show-total
            show-sizer />
          <Modal v-model="showDetailModal" title="详情" :z-index="22000" @on-cancel="closeDetailModal">
            <table class="detail-table" v-if="currentModel&&currentModel.name">
              <tr>
                <th>名称</th>
                <td>{{ currentModel.name }}</td>
              </tr>
              <tr>
                <th>标题</th>
                <td>{{ currentModel.title }}</td>
              </tr>
              <tr>
                <th>显示标题</th>
                <td>{{ currentModel.showTitle }}</td>
              </tr>
              <tr>
                <th>是否为附件</th>
                <td>{{ currentModel.isAttachment }}</td>
              </tr>
              <tr>
                <th>是否为企业自评项</th>
                <td>{{ currentModel.isSelfAppraise }}</td>
              </tr>
              <tr>
                <th>总分</th>
                <td>{{ currentModel.totalScore }}</td>
              </tr>
              <tr>
                <th>评分表达式</th>
                <td>{{ currentModel.scoreFormula }}</td>
              </tr>
              <tr>
                <th>题目数量</th>
                <td>{{ currentModel.questionCount }}</td>
              </tr>
              <tr>
                <th>创建时间</th>
                <td>{{ $moment(currentModel.createTime).format('YYYY-MM-DD HH:mm:ss') }}</td>
              </tr>
            </table>
          </Modal>
        </div>
        <div slot="bottom" class="split-pane">
          <Table border ref="dataTable"
            size="small"
            stripe
            draggable
            width="100%"
            @on-drag-drop="dragDrop"
            :columns="sectionColumns"
            :data="sections">
          </Table>
        </div>
      </Split>
    </div>
  </Drawer>
</template>

<script>
export default {
  name: 'section-picker',
  props: {
    show: {
      type: Boolean,
      default: () => false
    },
    paperId: {
      type: String,
      default: () => null
    }
  },
  data () {
    return {
      showSectionPicker: false,
      tableToolsPanel: '',
      split: 0.5,
      columns: [
      {
          title: '名称',
          key: 'name',
          resizable: true,
          sortable: 'custom'
        },
        {
          title: '标题',
          key: 'title',
          resizable: true,
          sortable: 'custom'
        },
        {
          title: '显示标题',
          key: 'showTitle',
          sortKey: 'showTitle',
          width: 120,
          resizable: true,
          render: (h, params) => {
            return h('span', null, params.row.showTitle ? '是' : '否')
          }
        },
        {
          title: '附件',
          key: 'isAttachment',
          sortKey: 'isAttachment',
          width: 120,
          resizable: true,
          render: (h, params) => {
            return h('span', null, params.row.isAttachment ? '是' : '否')
          }
        },
        {
          title: '自评项',
          key: 'isSelfAppraise',
          sortKey: 'isSelfAppraise',
          width: 120,
          resizable: true,
          render: (h, params) => {
            return h('span', null, params.row.isSelfAppraise ? '是' : '否')
          }
        },
        {
          title: '总分',
          key: 'totalScore',
          resizable: true,
          sortable: 'custom',
        },
        {
          title: '题目数量',
          key: 'questionCount',
          resizable: true,
        },
        {
          title: '操作',
          render: (h, params) => {
            return h('span', null, [
              h('Tooltip', {
                props: {
                  content: '详情',
                  transfer: true
                }
              }, [
                h('Button', {
                  props: {
                    type: 'primary',
                    ghost: true,
                    shape: 'circle',
                    icon: 'md-list-box',
                    size: 'small'
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      this.currentModel = params.row
                      this.showDetailModal = true
                    }
                  }
                }, null)
              ]),
              h('Tooltip', {
                props: {
                  content: '选择',
                  transfer: true
                }
              }, [
                h('Button', {
                  props: {
                    type: 'primary',
                    ghost: true,
                    shape: 'circle',
                    icon: 'md-add',
                    size: 'small'
                  },
                  on: {
                    click: () => {
                      this.addSectionToPaper(params.row)
                    }
                  }
                }, null)
              ]),
            ])
          }
        }
      ],
      data: [],
      pageSize: 10,
      totalCount: 0,
      currentPageIndex: 1,
      filterModel: {
        name: null,
        title: null,
        isSelfAppraise: null,
        isAttachment: null,
        excludeIds: null
      },
      selectedSections: [],
      currentModel: null,
      showDetailModal: false,
      sectionColumns: [
        {
          title: '#',
          key: 'rank',
          width: 50
        },
        {
          title: '名称',
          key: 'name',
          width: 100,
          resizable: true,
          sortable: 'custom'
        },
        {
          title: '标题',
          key: 'title',
          width: 150,
          resizable: true,
          sortable: 'custom'
        },
        {
          title: '显示标题',
          key: 'showTitle',
          sortKey: 'showTitle',
          width: 100,
          resizable: true,
          render: (h, params) => {
            return h('span', null, params.row.showTitle ? '是' : '否')
          }
        },
        {
          title: '附件',
          key: 'isAttachment',
          sortKey: 'isAttachment',
          width: 80,
          resizable: true,
          render: (h, params) => {
            return h('span', null, params.row.isAttachment ? '是' : '否')
          }
        },
        {
          title: '自评项',
          key: 'isSelfAppraise',
          sortKey: 'isSelfAppraise',
          width: 80,
          resizable: true,
          render: (h, params) => {
            return h('span', null, params.row.isSelfAppraise ? '是' : '否')
          }
        },
        {
          title: '总分',
          key: 'totalScore',
          resizable: true,
          width: 80,
          sortable: 'custom',
        },
        {
          title: '题目数量',
          key: 'questionCount',
          width: 100,
          resizable: true,
        },
        {
          title: '操作',
          width: 120,
          fixed: 'right',
          render: (h, params) => {
            return h('span', null, [
              h('Tooltip', {
                props: {
                  content: '详情',
                  transfer: true
                }
              }, [
                h('Button', {
                  props: {
                    type: 'primary',
                    ghost: true,
                    shape: 'circle',
                    icon: 'md-list-box',
                    size: 'small'
                  },
                  on: {
                    click: () => {
                      this.currentModel = params.row
                      this.showDetailModal = true
                    }
                  }
                }, null)
              ]),
              h('Tooltip', {
                props: {
                  content: '删除',
                  transfer: true
                }
              }, [
                h('Button', {
                  style: {
                    marginLeft: '5px'
                  },
                  props: {
                    type: 'error',
                    ghost: true,
                    shape: 'circle',
                    icon: 'md-remove',
                    size: 'small'
                  },
                  on: {
                    click: () => {
                      this.deleteItem(params.row)
                    }
                  }
                }, null)
              ])
            ])
          }
        }
      ],
      sections: []
    }
  },
  watch: {
    show: async function (newVal) {
      console.log('show', newVal)
      if (newVal) {
        if (this.paperId) {
          await this.getDetail()
        }
        this.initData()
        this.showSectionPicker = newVal
      }
    },
    currentPageIndex: function (newVal) {
      if (newVal) {
        this.initData()
      }
    },
    pageSize: function (newVal) {
      if (newVal) {
        this.initData()
      }
    },
  },
  computed: {
    expandText () {
      return (this.tableToolsPanel.indexOf('filter') > -1 ? '隐藏' : '展开') + '筛选条件'
    }
  },
  mounted () {
  },
  activated () {
  },
  deactivated () {
  },
  methods: {
    async dragDrop (index1, index2) {
      let item1 = JSON.parse(JSON.stringify(this.sections[parseInt(index1)]))
      let item2 = this.sections[parseInt(index2)]
      let paperId = this.paperId
      let sectionId = item1.tid
      let oldRank = item1.rank
      let targetRank = item2.rank
      console.log(paperId, sectionId, oldRank, targetRank)
      await this.moveRank(paperId, sectionId, targetRank)
        .then(() => {
          item1.rank = targetRank
          this.sections.splice(parseInt(index1), 1)
          this.sections.splice(parseInt(index2), 0, item1)
          this.rerankItems()
        })
    },
    rerankItems () {
      this.sections.forEach((sec, idx) => {
        sec.rank = idx + 1
      })
    },
    moveRank (paperId, sectionId, targetRank) {
      return new Promise((resolve, reject) => {
        this.$Api.Appraisal.moveSectionRank({
          paperId: paperId,
          sectionId: sectionId,
          rank: targetRank
        }).then(() => {
          this.$Message.success('操作成功!')
          resolve()
        })
        .catch(err => {
          this.$Notice.error({
            title: '操作失败!',
            desc: err.message
          })
          // this.$Spin.hide()
          reject(err)
        })
      })
    },
    closePicker () {
      this.showSectionPicker = false
      this.$emit('close-picker')
    },
    getDetail () {
      return new Promise((resolve) => {
        if (this.paperId) {
          this.$Api.Appraisal.getAppraisalPaper(this.paperId).then((payload) => {
            if (payload && payload.sections) {
              this.sections = payload.sections
              let ids = payload.sections.map(q => {
                return q.tid
              })
              this.filterModel.excludeIds = ids
              resolve()
            }
          })
        }
      })
    },
    closeDetailModal () {
      this.currentModel = null
      this.showDetailModal = false
    },
    checkRolePermitted (roles) {
      if (this.$store.getters.userInfo.type === 127) {
        return true
      }
      let userRole = this.$common.userType[this.$store.getters.userInfo.type.toString()]
      if (roles instanceof Array) {
        return roles.indexOf(userRole) > -1
      }
      return roles == userRole
    },
    refresh () {
      // console.log('123')
      this.initData()
    },
    changePageSize (e) {
      this.pageSize = e
    },
    changePageIndex (e) {
      this.currentPageIndex = e
    },
    tableSortChange (e) {
      if (e.key) {
        this.filterModel.sortBy = e.column.sortKey || e.key
        this.filterModel.ascending = e.order === 'normal' ? null : e.order == 'asc' ? true : false
        this.initData()
      }
    },
    async initData () {
      console.log('initdata')
      this.$Spin.show()
      let ids = []
      if (this.sections.length) {
        ids = this.sections.map(q => {
          return q.tid
        })
        this.filterModel.excludeIds = ids
      }
      let res = await this.$Api.Appraisal.listSection(this.filterModel, this.currentPageIndex, this.pageSize).catch(err => {
        this.$Message.error(err.message)
        this.$Spin.hide()
      })
      this.totalCount = res.totalCount
      this.data = res.data
      this.$Spin.hide()
    },
    async addSectionToPaper (sectionItem) {
      if (!this.paperId) {
        this.$Message.error('大题ID为空!')
        return false
      }
      await this.$Api.Appraisal.addSectionsToPaper({
        sectionIds: [sectionItem.tid],
        paperId: this.paperId
      }).catch(err => {
        this.$Notice.error({
          title: '操作失败!',
          desc: err.message
        })
        // this.$Spin.hide()
        return null
      })
      this.$Message.success('操作成功!')
      let lastRank = this.sections.length ? this.sections[this.sections.length - 1].rank : 0
      sectionItem.rank = lastRank + 1
      this.sections.push(sectionItem)
      this.data.splice(this.data.findIndex(o => {return o.tid === sectionItem.tid}), 1)
      this.totalCount -= 1
    },
    async deleteItem (sectionItem) {
      if (!this.paperId) {
        this.$Message.error('大题ID为空!')
        return false
      }
      this.$Modal.confirm({
        title: '确认操作',
        content: '<p>确认移除该题目么？</p>',
        onOk: async () => {
          // this.$Spin.show()
          await this.$Api.Appraisal.removeSectionsFromPaper({
            paperId: this.paperId,
            sectionIds: [sectionItem.tid]
          }).catch(err => {
            this.$Notice.error({
              title: '操作失败!',
              desc: err.message
            })
            // this.$Spin.hide()
            return null
          })
          this.$Message.success('操作成功!')
          let lastRank = sectionItem.rank
          this.sections.forEach((q, qIdx) => {
            if (qIdx == lastRank) {
              q.rank = lastRank
              lastRank++
            }
          })
          this.sections.splice(this.sections.findIndex(o => {return o.tid === sectionItem.tid}), 1)
          this.data.push(sectionItem)
          this.totalCount += 1
        },
        onCancel: () => {
        }
      })
    },
  }
}
</script>

<style lang="less" scoped>
.table-tools-panel {
  .table-tools-panel-title {
    font-weight: bold;
    display: inline-block;
  }
  .table-tools-panel-title-icon {
    margin-right: 20px;
  }
  .table-tools-panel-title-addon {
    display: inline-block;
    margin-left: 20px;
  }
}
.pager {
  margin: 20px 0;
}
.section-picker {
  height: 100%;
  overflow: hidden;
}
.split-pane {
  padding: 10px;
  overflow-y: auto;
  overflow-x: hidden;
  background: #fff;
  height: 100%;
}
</style>
